import React from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';

import {
  Box,
  ButtonBase,
  Card,
  Divider,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
  ButtonNext,
  CarouselProvider,
  Slide,
  Slider,
} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';

import { ReactComponent as RightIcon } from '../../../assets/img/icon/Right.svg';
import { appConfig } from '../../../config/app';
import { getFormattedDate } from '../../../helpers/getDate';

const useStyles = makeStyles((theme) => ({
  root: {
    background: `linear-gradient(79.82deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
  },
  container: {
    position: 'relative',
    maxWidth: '100%',
    margin: 'auto',
  },
  buttonNext: {
    background: 'transparent',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '4px',
    position: 'absolute',
    top: '50%',
    right: '-16px',
    transform: 'translateY(-50%)',
    padding: '2px',
  },
  text: {
    color: theme.palette.secondary.contrastText,
  },
}));

const useStyleCards = makeStyles((theme) => ({
  root: {
    background: `#6A6A6A`,
    // background: `linear-gradient(79.82deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
  },
  divider: {
    background: '#fff',
  },
  text: {
    color: '#FFF',
    fontFamily: 'Inter',
    // color: theme.palette.secondary.contrastText,
  },
}));

interface CirculationCardProps {
  data: any;
}

let CirculationCardImg = appConfig?.IMAGES?.CIRCULATION_CARD;

const CirculationCard: React.FC<CirculationCardProps> = ({ data }) => {
  const classes = useStyleCards();

  return (
    <Box py={1} px={1}>
      {/* <ButtonBase> */}
      <ButtonBase component={Link} to={`/circulation-card/${data.id}`}>
        <Card className={classes.root}>
          <Box m={2}>
            <Grid container>
              <Grid item xs={12}>
                <Box
                  mb={2}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography className={classes.text}>
                      {data.brand + ' ' + data.model + ' '}{' '}
                    </Typography>
                    <Typography variant="caption" className={classes.text}>
                      {data.year + '/' + data.license_plate}
                    </Typography>
                  </Box>
                  <CirculationCardImg />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Divider className={classes.divider}></Divider>
              </Grid>
              <Grid item xs={12}>
                <Box
                  my={2}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    flexWrap="wrap"
                  >
                    <Typography className={classes.text}>
                      {' '}
                      Vencimiento de póliza{' '}
                    </Typography>
                    <Box ml={1}>
                      <Typography className={classes.text}>
                        {getFormattedDate(data.policy.expires_at)}
                      </Typography>
                    </Box>
                  </Box>
                  <Typography className={classes.text}>
                    Póliza: {data.policy.number}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </ButtonBase>
    </Box>
  );
};

const CirculationCards = ({ data }) => {
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const vehiclesToShow = data?.filter(
    (vehicle: any) => vehicle.policy.status === 'active'
  );

  return vehiclesToShow?.length >= 10 ? (
    <Box py={1} px={1}>
      <ButtonBase component={Link} to="/circulation-cards">
        <Card className={classes.root}>
          <Box m={2}>
            <Grid container>
              <Grid item xs={12}>
                <Box
                  mb={3}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Box>
                    <Typography variant="h6" className={classes.text}>
                      {' '}
                      Accedé a las tarjetas de tus vehículos{' '}
                    </Typography>
                  </Box>
                  <Box>{/* <CirculationCardImg /> */}</Box>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Card>
      </ButtonBase>
    </Box>
  ) : vehiclesToShow?.length > 2 ? (
    <CarouselProvider
      naturalSlideWidth={80}
      naturalSlideHeight={500}
      totalSlides={vehiclesToShow.length}
      isIntrinsicHeight
      visibleSlides={matches ? 1 : 2}
      infinite
      isPlaying
      interval={5000}
    >
      <div className={classes.container}>
        <Slider>
          {vehiclesToShow?.map((vehicle: any, index: number) => (
            <Slide key={index} index={index}>
              <CirculationCard data={vehicle}></CirculationCard>
            </Slide>
          ))}
        </Slider>
        <ButtonNext className={classes.buttonNext}>
          <RightIcon />
        </ButtonNext>
      </div>
    </CarouselProvider>
  ) : (
    <Grid container>
      {vehiclesToShow?.map((vehicle: any, index: number) => (
        <Grid key={index} xs={12} md={6} item>
          <CirculationCard data={vehicle}></CirculationCard>
        </Grid>
      )) || null}
    </Grid>
  );
};

export default CirculationCards;
